import React, {useState, useEffect} from "react";
import { Link, NavLink } from "react-router-dom";
import css from "./footer.module.css";
import resources from "../../resources";
import { BsFillStarFill } from "react-icons/bs";
import {FaFacebook, FaInstagram, FaDribbble, FaGithub} from 'react-icons/fa'

import { useLocation } from "react-router-dom";
const Footer = () => {

  const location = useLocation();
  const [isFooterScrolled, setIsFooterScrolled] = useState(false); //use to change bg f header on scroll


  useEffect(() => {
    if (location.pathname === "/home") {
      setIsFooterScrolled(false); //this Means Blue Footer(like in home page)
    } else if (location.pathname === "/about") {
      setIsFooterScrolled(true); //this Means White footer
    } else if (location.pathname === "/service") {
      setIsFooterScrolled(true);
    } else {
      setIsFooterScrolled(false);
    }
  }, [isFooterScrolled]);



  return (
    <div className={`${css.wrapper}  ${isFooterScrolled ? css.scrolled_wrapper : ''}`}>
      <div className={css.top_part}>

        <div className={css.first}>
            {!isFooterScrolled ? <img src={resources.icons.logo} alt="LOGO" /> : <img src={resources.icons.logo_scrolled} alt="LOGO" />}
      
          <p>
            Our latest news, articles, and resources, we will sent to your inbox
            weekly.
          </p>
          <form className={css.subscribe}>
            <input type="email" required placeholder="Enter you Email" />
            <button>Subscribe</button>
          </form>
          <h4>10/10 Overall rating</h4>
          <div className={css.stars}>
            <BsFillStarFill />
            <BsFillStarFill />
            <BsFillStarFill />
            <BsFillStarFill />
            <BsFillStarFill />
          </div>
        </div>

        <div className={css.second}>
          <h3>Primary Pages</h3>
          <div className={`${css.link_div}  ${isFooterScrolled ? css.scrolled_link_div : ''}`}>
            <NavLink to="/home" className={css.link}>
              Home
            </NavLink>
            <NavLink to="/About Us" className={css.link}>
              About Us
            </NavLink>
            <NavLink to="/Services" className={css.link}>
              Services
            </NavLink>
            <NavLink to="/Carrer" className={css.link}>
              Carrer
            </NavLink>
            <NavLink to="/Integrations" className={css.link}>
              Integrations
            </NavLink>
            <NavLink to="/Integration Single" className={css.link}>
              Integration Single
            </NavLink>
          </div>
        </div>
        <div className={css.second}>
          <h3>Pages</h3>
          <div className={`${css.link_div}  ${isFooterScrolled ? css.scrolled_link_div : ''}`}>
            <NavLink to="/Pricing" className={css.link}>
              Pricing
            </NavLink>
            <NavLink to="/News" className={css.link}>
              News
            </NavLink>
            <NavLink to="/News Details" className={css.link}>
              News Details
            </NavLink>
            <NavLink to="/Contact" className={css.link}>
              Contact
            </NavLink>
            <NavLink to="/Career Single" className={css.link}>
              Career Single
            </NavLink>
            <NavLink to="/Service Single" className={css.link}>
              Service Single
            </NavLink>
          </div>
        </div>
        <div className={css.second}>
          <h3>Template</h3>
          <div className={`${css.link_div}  ${isFooterScrolled ? css.scrolled_link_div : ''}`}>
            <NavLink to="/Contact" className={css.link}>
              Contact
            </NavLink>
            <NavLink to="/Support" className={css.link}>
              Support
            </NavLink>
            <NavLink to="/Support Single" className={css.link}>
              Support Single
            </NavLink>
            <NavLink to="/Our Team" className={css.link}>
              Our Team
            </NavLink>
            <NavLink to="/User Login" className={css.link}>
              User Login
            </NavLink>
            <NavLink to="/Career   Single" className={css.link}>
              Career   Single
            </NavLink>
          </div>
        </div>

      </div>
      <hr className={css.hr} />
      <div className={css.bottom_part}>
        <p>
          @{new Date().getFullYear()} Quiety Rights Reserved. Designed By{" "}
          <Link className={css.link}>ThemeTags</Link>
        </p>
        <div className={css.social_icons}>
          <FaFacebook className={css.icon} />
          <FaInstagram className={css.icon}  />
          <FaDribbble className={css.icon}  />
          <FaGithub className={css.icon}  />
        </div>
      </div>
    </div>
  );
};

export default Footer;
